// eslint-disable-next-line no-restricted-imports
import {
  Query_ClientController_GetById_Category as CategoryApi,
  Query_ClientController_GetList_AllOf_1_List_Items_Category as CategoryApi1,
} from 'api/generated/graphql';
import { ClientCategoryType } from 'api/types/entity';
import { Maybe } from 'types/maybe';

const category: Record<CategoryApi, ClientCategoryType> = {
  [CategoryApi.NonResident]: ClientCategoryType.NonResident,
  [CategoryApi.Resident]: ClientCategoryType.Resident,
  [CategoryApi.AifcParticipant]: ClientCategoryType.AIFCParticipant,
  [CategoryApi.KazakhstanResidenceExceptAifcParticipants]:
    ClientCategoryType.KazakhstanResidenceExceptAIFCParticipants,
  [CategoryApi.CentralAsiaResidenceExceptKazakhstan]:
    ClientCategoryType.CentralAsiaResidenceExceptKazakhstan,
  [CategoryApi.AsiaResidenceExceptCentralAsia]:
    ClientCategoryType.AsiaResidenceExceptCentralAsia,
  [CategoryApi.EuropeResidence]: ClientCategoryType.EuropeResidence,
  [CategoryApi.AmericasResidence]: ClientCategoryType.AmericasResidence,
  [CategoryApi.AustraliaResidence]: ClientCategoryType.AustraliaResidence,
  [CategoryApi.AfricaResidence]: ClientCategoryType.AfricaResidence,
  [CategoryApi.RussianFederationResidence]:
    ClientCategoryType.RussianFederationResidence,
};

export const parseCategoryType = (
  data: Maybe<CategoryApi | CategoryApi1>
): ClientCategoryType | undefined => (data ? category[data] : undefined);
